import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import FastImage from '../../components/Interface/Images/FastImageWithFallback';
import Feather from 'react-native-vector-icons/Feather';

import {KeyboardAwareScrollView} from 'react-native-keyboard-aware-scroll-view';

export const Container = styled(KeyboardAwareScrollView)`
  background-color: ${({theme}) => theme.colors.background};
`;
//@ts-ignore

//export const Content = styled(Animated.View)`
export const Content = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  margin-top: -${RFValue(20)}px;
`;

export const Divider = styled.View`
  height: 1px;
  background-color: ${({theme}) => theme.colors.border2};
  margin: ${RFValue(12)}px 0;

`;

export const SectionHeader = styled.View`
  margin: 0 24px;
`;

export const Section = styled.View`
  border-style: solid;
  border-color: ${({theme}) => theme.colors.border2};
  border-bottom-width: 1px;
  padding-bottom: ${RFValue(14)}px;
  margin-bottom: ${RFValue(14)}px;
`;

export const SectionContainer = styled.View`
  margin: 0 24px;
`;

export const SectionImage = styled.View`
  width: 100%;
  height: ${RFValue(80)}px;
  padding: 0 24px;
  margin-top: ${RFValue(12)}px;
`;

export const Panel = styled.TouchableOpacity`
  margin-right: ${RFValue(12)}px;
  width: 100%;
  height: ${RFValue(80)}px;
`;

//@ts-ignore
export const Image = styled(FastImage)`
  width: 100%;
  height: ${RFValue(80)}px;
  border-radius: ${RFValue(12)}px;
`;

export const Title = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(13)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  margin-bottom: ${RFValue(12)}px;
`;

export const AccountMenuContainer = styled.View`
  margin: 0 24px;
`;

export const BannerImage = styled(FastImage)`
  aspect-ratio: 16/9;
  margin: 0 24px;
  border: 1px solid rgba(201, 155, 31, 0.38);
  border-radius: ${RFValue(16)}px;

  `;
/* ─── Emprestimo Alert Card ─── */
type AlertVariant = 'red' | 'orange';

interface AlertCardProps {
  variant: AlertVariant;
}

export const EmprestimoAlertCard = styled.TouchableOpacity<AlertCardProps>`
  flex-direction: row;
  align-items: center;
  border-radius: ${RFValue(12)}px;
  
  border-width: 1.5px;
  padding: ${RFValue(10)}px ${RFValue(12)}px;
  gap: ${RFValue(10)}px;
  background-color: ${({theme, variant}) =>
    variant === 'red' ? theme.colors.alert_red_bg : theme.colors.alert_orange_bg};
  border-color: ${({theme, variant}) =>
    variant === 'red' ? theme.colors.alert_red_border : theme.colors.alert_orange_border};
`;

export const EmprestimoAlertIconWrapper = styled.View<AlertCardProps>`
  width: ${RFValue(32)}px;
  height: ${RFValue(32)}px;
  border-radius: ${RFValue(16)}px;
  justify-content: center;
  align-items: center;
  background-color: ${({theme, variant}) =>
    variant === 'red' ? theme.colors.alert_red_bg : theme.colors.alert_orange_bg};
`;

export const EmprestimoAlertIcon = styled(Feather)<AlertCardProps>`
  font-size: ${RFValue(16)}px;
  color: ${({theme, variant}) =>
    variant === 'red' ? theme.colors.alert_red_icon : theme.colors.alert_orange_icon};
`;

export const EmprestimoAlertContent = styled.View`
  flex: 1;
`;

export const EmprestimoAlertTitle = styled.Text<AlertCardProps>`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme, variant}) =>
    variant === 'red' ? theme.colors.alert_red_title : theme.colors.alert_orange_title};
  margin-bottom: ${RFValue(1)}px;
`;

export const EmprestimoAlertSubtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.text};
  line-height: ${RFValue(14)}px;
`;

export const EmprestimoAlertValue = styled.Text<AlertCardProps>`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(15)}px;
  margin-top: ${RFValue(4)}px;
  color: ${({theme, variant}) =>
    variant === 'red' ? theme.colors.alert_red_title : theme.colors.alert_orange_title};
`;

export const EmprestimoAlertButton = styled.TouchableOpacity<AlertCardProps>`
  width: ${RFValue(34)}px;
  height: ${RFValue(34)}px;
  border-radius: ${RFValue(17)}px;
  align-items: center;
  justify-content: center;
  background-color: ${({theme, variant}) =>
    variant === 'red' ? theme.colors.alert_red_icon : theme.colors.alert_orange_icon};
`;

export const EmprestimoAlertButtonIcon = styled(Feather)`
  font-size: ${RFValue(16)}px;
  color: #fff;
`;

export const EmprestimoAlertChevron = styled(Feather)<AlertCardProps>`
  font-size: ${RFValue(15)}px;
  color: ${({theme, variant}) =>
    variant === 'red' ? theme.colors.alert_red_icon : theme.colors.alert_orange_icon};
`;
